import React from "react";
import ProfilePhoto from "../../assets/images/Images/profile.jpeg";
import BadgeSerbian from "../../assets/images/Icons/30yearBage.png";
import BadgeGerman from "../../assets/images/Icons/30 Jahren.png";
import de from "../../assets/texts/de.json";
import sr from "../../assets/texts/sr.json";
import { useLanguage } from "../../i18n/LanguageContext";
import AOS from "aos";
import "aos/dist/aos.css";

export default function HomeSection() {
  AOS.init({ duration: 2000 });
  const { language } = useLanguage();
  const t = language === "sr" ? sr : de;
  const Badge = language === "sr" ? BadgeSerbian : BadgeGerman;
  return (
    <div className="home-section">
      <div className="shadow-container">
        <img
          className="badge"
          src={Badge}
          alt="30 years of experience badge"
          data-aos="fade-left"
        />
        <div className="signature-container" data-aos="fade-up">
          <img src={ProfilePhoto} alt="CEO" />
          <div className="profile-wrapper">
            <p className="signature">Muro Mark</p>
            <p className="position">{t.homeSection.position}</p>
          </div>
        </div>
        <div className="home-title" data-aos="fade-left">
          <h1>
            {t.homeSection.title.split(". ").map((part, idx) => (
              <React.Fragment key={idx}>
                {part}
                {idx < 2 && <><br /> </>}
              </React.Fragment>
            ))}
          </h1>
        </div>
      </div>
    </div>
  );
}
